import {Component, h} from "preact";
import {icons} from "../icons";
import styles from "./style.module.scss"
import {FilterMap, ProductFilter} from "../../models/filter";
import {filterService} from "../../services/filter-service";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {FilterType} from "../../models/product";
import {customerService} from "../../services/customer-service";
import {Like} from "../../models/customer";
import {i18nService} from "../../services/i18n-service";
import {Collection} from "../../models/collection";
import {imageService} from "../../services/image-service";
import {NY_Tracker, TrackingEvent} from "../../services/tracking-service";

interface Props {
    toggleFilter(filter: ProductFilter);

    toggleIsFilterModalDisplayed(show?: boolean);

    openInterstitial();

    filters: FilterMap;
    likes: Like[];

    filter: ProductFilter;
    collections: Collection[];
    isCustomFilter: boolean;
    isBubbleFilter: boolean;
}

const mapToProps = ({filters, likes, collections}) => ({filters, likes, collections});

class Filter extends Component<Props, any> {

    private _toggleFilter(filter: ProductFilter) {
        //this.props.toggleFilter(filter);
        window.scrollTo({top: 0, behavior: "smooth"});
        this.props.toggleIsFilterModalDisplayed(false);

        let event = {
            label: `${this.props.filters.gender} - ${filterService.getTranslationKey(filter, this.props.filters.gender)}`,
            action: 'SelectFilter: ' + filter.type,
            category: 'Products'
        };

        NY_Tracker.trackClick(event as TrackingEvent);
    }

    render() {
        const filter = this.props.filter;

        if (filter.type === FilterType.Like) {
            return (
                <div class={`${styles['like-filter']} ${filter.selected ? styles.selected : ''}`}>
                    {customerService.isLoggedIn ? (
                        <a
                            href={this.props.filters.toggleFilterUrl(filter)}
                            onClick={() => this._toggleFilter(filter)}
                            title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                        >
                            <span className={`${styles.heart} ${customerService.isLoggedIn && this.props.likes ? styles.fill : ''}`}>{icons.renderHeartIcon()}</span>
                            {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                            <span className={styles['likes-count']}>{customerService.isLoggedIn && `(${this.props.likes.filter(like => like.product).length})`}</span>
                            {filter.selected &&
                                <span className={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                            }
                        </a>
                    ) : (
                        <span
                            onKeyPress={(e) => {if(e.key === 'Enter') this.handleLikeFilterToggle(filter)}}
                            tabIndex={0}
                            onClick={() => this.handleLikeFilterToggle(filter)}
                            title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                        >
                            <span className={`${styles.heart} ${customerService.isLoggedIn && this.props.likes ? styles.fill : ''}`}>{icons.renderHeartIcon()}</span>
                            {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                            <span className={styles['likes-count']}>{customerService.isLoggedIn && `(${this.props.likes.filter(like => like.product).length})`}</span>
                            {filter.selected &&
                                <span className={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                            }
                        </span>
                    )}
                </div>
            )
        } else if (filter.type === FilterType.Editorial) {
            if (this.props.isBubbleFilter) {
                return (
                    <a
                        href={this.props.filters.toggleFilterUrl(filter)}
                        onClick={() => this._toggleFilter(filter)}
                        title={filter.name}
                        className={styles["bubble-filter-wrapper"]}
                    >
                        <div className={`${styles['bubble-filter']} ${this.props.filters.editorials.length <= 4 ? styles['few'] : ''}`}>
                            <img src={imageService.getImagePreviewUrl(filter.image_key)}/>
                            <div className={styles['bubble-editorial-name']}>{filter.name}</div>
                        </div>
                    </a>
                )
            }

            return (
                <div class={`${styles['default-filter']} ${filter.selected ? styles.selected : ''}`}>
                    <a
                        href={this.props.filters.toggleFilterUrl(filter)}
                        onClick={() => this._toggleFilter(filter)}
                        title={filter.name}
                    >
                        {filter.name}
                        {filter.selected &&
                            <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                        }
                    </a>
                </div>
            )
        } else return (
            <div class={`${this.props.isCustomFilter ? styles['custom-filter'] : styles['default-filter']} ${this.props.isCustomFilter && filter.name === 'sale' ? styles['sale-filter'] : ''} ${filter.selected ? styles.selected : ''}`}>
                <a
                    href={this.props.filters.toggleFilterUrl(filter)}
                    onClick={() => this._toggleFilter(filter)}
                    title={i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                >
                    {i18nService.translate(filterService.getTranslationKey(filter, this.props.filters.gender))}
                    {filter.selected &&
                        <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                    }
                </a>
                {filter.expanded &&
                    <div class={`${styles['sub-filter']}`}>
                        {filter.filters.map((subFilter: ProductFilter) => {
                            return (
                                <div class={`${styles['default-filter']} ${!filter.selected && subFilter.selected ? styles.selected : ''}`}>
                                    <a
                                        href={this.props.filters.toggleFilterUrl(subFilter)}
                                        onClick={() => this._toggleFilter(filter)}
                                        title={i18nService.translate(filterService.getTranslationKey(subFilter, this.props.filters.gender))}
                                    >
                                        {i18nService.translate(filterService.getTranslationKey(subFilter, this.props.filters.gender))}
                                        {!filter.selected && subFilter.selected &&
                                            <span class={styles['filter-selected-icon']}>{icons.renderCheckIcon()}</span>
                                        }
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                }
            </div>
        )
    }

    handleLikeFilterToggle(filter: ProductFilter) {
        if (customerService.isLoggedIn) {
            this.props.toggleFilter(filter)
        } else {
            this.props.openInterstitial();
        }
        this.props.toggleIsFilterModalDisplayed(false);
    }
}

export default connect(mapToProps, actions)(Filter)
